import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { fetchDispath } from '../../functions/fetch'
import { gost } from './types'
import { getProjectJournalById, getProjectJournalRow, deleteProjectJournalRowById, getProjectJournalPrint } from '../../api/journals'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import PageList from '../../components/PageListAPI'
import moment from 'moment'
import 'moment/locale/ru';
import { Grid, Typography, Button } from '@mui/material'
import print from '../../functions/print'
import { useCan } from 'src/hooks/useCan'
import { SLUGS } from 'src/enum/permissions.enum'

export default function JournalCablesOne() {
  const params = useParams()
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [gostCode, setGostCode] = useState(null)
  const [props, setProps] = useState({
    createdAt: '',
    createdBy: '',
    gostRef: '',
    journalNumber: '',
    stage: '',
    systemCode: '',
    title: ''
  })
  const [columns, setColumns] = useState([])
  useEffect(() => {
    dispatch(fetchDispath({
      param: {
        idProject: params.idProject,
        id: params.idDoc,
      },
      progress: true,
      request: getProjectJournalById,
    })).then(res => {
      setGostCode(res.get.gostCode)
      setProps({
        createdAt: res.get.createdAt,
        createdBy: res.get.createdBy,
        gostRef: res.get.gostRef,
        journalNumber: res.get.journalNumber,
        stage: res.get.stage,
        systemCode: res.get.systemCode,
        title: res.get.title,
      })
    }).catch(err => console.log(err))
  }, [dispatch, params])
  useEffect(() => {
    const obj = gost[gostCode]
    if (!obj) return;
    const arr = [{ id: 'rowNumber', name: 'Номер', width: 50 },]
    Object.keys(obj).forEach(key => {
      arr.push({ id: key, name: obj[key].label })
    })
    setColumns(arr)
  }, [gostCode])
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      title={`Журнал №${props.journalNumber}: ${props.title}`}
      name='journal_cables-row'
      columns={columns}
      createItem={can(SLUGS.PROJECT.JOURNAL.CREATE_RECORDS)}
      deleteItem={can(SLUGS.PROJECT.JOURNAL.DELETE_RECORDS)}
      loadAPI={{
        param: {
          idProject: params.idProject,
          id: params.idDoc
        },
        request: getProjectJournalRow,
      }}
      deleteAPI={deleteProjectJournalRowById(params.idProject, params.idDoc)}
      headerInit={{
        sortBy: 'createdAt',
        sortDirection: 'desc',
      }}
      location={location}
      history={history}
      click={false}
      headerObj={<JournalCablesOneHeader props={props} idDoc={params.idDoc} idProject={params.idProject} />}
    />
  </div>
}

function JournalCablesOneHeader({ props, idDoc,idProject }) {
  const dispatch = useDispatch()
  const fetch = useCallback((obj) => { return dispatch(fetchDispath(obj)) }, [dispatch])
  const handlePrint = () => {
    print(
      fetch,
      {
        param: {
          id: idDoc,
          idProject: idProject
        },
        request: getProjectJournalPrint,
      }
    )
  }
  return <div>
    <Grid
      item
      container
      xs={9}
    >
      <GridProps name='Дата' value={moment(props.createdAt).format('LLL')} />
      <GridProps name='Создан' value={props.createdBy} />
      <GridProps name='ГОСТ' value={props.gostRef} />
      <GridProps name='Стадия' value={props.stage} />
      <GridProps name='Система' value={props.systemCode} />
    </Grid>
    <Button color='primary' onClick={handlePrint} >Печать </Button>
  </div>
}

function GridProps({ name = '', value = '', xsStart = 6, xsEnd = 6, typographyProps1 = {} }) {
  return <React.Fragment>
    <Grid item xs={xsStart}><Typography {...typographyProps1}>{name}</Typography></Grid>
    <Grid item xs={xsEnd}>{(typeof value === 'object') ? value : <Typography>{value}</Typography>}</Grid>
  </React.Fragment>
}